import React from "react";
import { Heading } from "@usap/uicomponents";
// 18px
export default function Heading4({ title = "", ...props }) {
  return (
    <Heading
      responsive={false}
      level={4}
      margin="0px"
      color="dark-2"
      {...props}
      dangerouslySetInnerHTML={{
        __html: title
      }}
    />
  );
}
